export const LOCALES = [
  'cs',
];
export const DEFAULT_LOCALE = 'cs';

export default {
  LOCALES,
  DEFAULT_LOCALE,
};
